import { sessionStorageClearAll } from '../storage/sessionStorageManager';
import IconCandidate from '../../assets/icons/candidate-1.svg';
import IconManager from '../../assets/icons/frame-1700.svg';
import { Link } from 'react-router-dom';
import { routes } from '../../containers/routes/routes-names';
import { useRegistration } from './RegistrationContext';
import { SignupTabs } from './SignupLayout';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const SelectAccountType = () => {
    const {
        setCheckIcon,
        setSignAs,
        setCandidateType,
        disableManagerTypeBtn,
        disableCandidateTypeBtn,
        setActiveTab,
        candidateType,
        checkIcon,
    } = useRegistration();

    const location = useLocation();
    const claimedType = location?.state?.data?.claimedType || sessionStorage.getItem('claimedType') || null;

    useEffect(() => {
        if (location?.state?.data?.claimedType) {
            sessionStorage.setItem('claimedType', location.state.data.claimedType);
        }
    }, [location]);

    return (
        <>
            <div className="card lt-shadow-sm">
                <div className="login-card-body">
                    <div className="flex-column">
                        <div className="w-100 mb-4 text-center">
                            <h1 className="fs-32 fw-600">Let's Get Started</h1>
                            <div className="fs-16 lt-text-secondary">Select Your Account Type</div>
                        </div>

                        <div className="mb-4">
                            <div className="mb-3">
                                <div className="">
                                    <label
                                        onClick={() => {
                                            sessionStorageClearAll();
                                            setCheckIcon('company');
                                            setSignAs('company');
                                            setCandidateType('company');
                                        }}
                                    >
                                        <button
                                            disabled={disableManagerTypeBtn}
                                            className={`${
                                                disableManagerTypeBtn && 'op-disabled'
                                            } panel panel-default card-input op-card-box`}
                                        >
                                            <div className="text-start">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex justify-content-start align-items-center">
                                                        <img
                                                            src={IconManager}
                                                            alt="Company"
                                                            width={36}
                                                            className="mb-0"
                                                        />
                                                        <div className="fs-16 mb-0 op-color ms-2 mt-1">Company</div>
                                                    </div>
                                                    <i
                                                        className={`bi ${
                                                            checkIcon === 'company'
                                                                ? 'bi-check-circle-fill lt-text-primary-alt'
                                                                : 'bi-circle lt-text-disabled'
                                                        } mt-0 fs-20`}
                                                    ></i>
                                                </div>
                                            </div>
                                        </button>
                                    </label>
                                </div>
                                <div className="mt-3">
                                    <label
                                        onClick={() => {
                                            sessionStorageClearAll();
                                            setCheckIcon('candidate');
                                            setCandidateType('candidate');
                                            setSignAs('candidate');
                                        }}
                                    >
                                        <input type="radio" name="product" className="card-input-element" />

                                        <button
                                            disabled={disableCandidateTypeBtn || claimedType === 'company'}
                                            className={`${
                                                (disableCandidateTypeBtn || claimedType === 'company') && 'op-disabled'
                                            } panel panel-default card-input op-card-box`}
                                        >
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex justify-content-start">
                                                    <img
                                                        src={IconCandidate}
                                                        alt="Candidate"
                                                        width={36}
                                                        className="mb-0"
                                                    />
                                                    <div className="fs-16 mb-0 op-color ms-2 mt-1">Candidate</div>
                                                </div>
                                                <i
                                                    className={`bi ${
                                                        checkIcon === 'candidate'
                                                            ? 'bi-check-circle-fill lt-text-primary-alt'
                                                            : 'bi-circle lt-text-disabled'
                                                    } mt-1 fs-20`}
                                                ></i>
                                            </div>
                                        </button>
                                    </label>
                                </div>
                            </div>
                            <button
                                disabled={Boolean(!candidateType)}
                                className="btn btn-primary w-100 h-44"
                                onClick={() => {
                                    setActiveTab(SignupTabs.AUTH_TYPE);
                                }}
                            >
                                Next
                            </button>
                            <div className="fs-14 mt-3 lt-text-secondary text-center">
                                Already have an account?{' '}
                                <Link to={routes.signinSignup}>
                                    <a className="lt-text-primary-alt cursor-pointer"> Log In</a>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SelectAccountType;
